import { combineReducers } from "redux";
import Auth from "./auth";
import Image from "./images";
import NavBar from "./navbar";
import User from "./user";
import Snackbar from "./snackbar";

const rootReducer = combineReducers({
  auth: Auth,
  imageList: Image,
  navBar: NavBar,
  user: User,
  snackbar: Snackbar
});

export default rootReducer;
